import { Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { LoadingService } from './../../../core/services/loading.service';
import { CustomerService } from 'src/app/core/services/customer.service';
import { LoginService } from 'src/app/core/services/login.service';
import { ConfigurationService } from 'src/app/core/services/configuration.service';
import { AuthorizationProperties } from './../../../authentication/auth-info';
import { MatTableDataSource } from '@angular/material/table';
import { ProductDto } from 'src/app/model/ProductDto';
import { OperationResult } from '@tb/auth';
import { VerticalSolutionsService } from 'src/app/core/services/verticalsolutions.service';
import { MatPaginator } from '@angular/material/paginator';

import { TranslatedVariables } from 'src/app/commons/translated-variables';
import { NavigateService } from 'src/app/core/services/navigate.service';
import { Router } from '@angular/router';
@Component({
    selector: 'ms-vertical-solutions-list',
    templateUrl: './vertical-solutions-list.component.html',
    styleUrls: ['./vertical-solutions-list.component.scss'],
})
export class VerticalSolutionsListComponent implements OnInit {
    public isLoading: boolean = false;
    noItems: boolean = false;
    searchSolution: string = '';
    solutionNumbers: number = 0;
    displayedColumns: string[] = ['signature','description','productCode', 'active', 'edit'];
    authorizationProperties: AuthorizationProperties;
    dataSourceVerticalSDetails: MatTableDataSource<ProductDto>;
    authorizationStored;
    _userspaginator: MatPaginator;


    @ViewChild('verticalSolutionsPaginator') set paginator(contentVerticalSolutions: MatPaginator) {
        if (contentVerticalSolutions) {
            this._userspaginator = contentVerticalSolutions;
            const paginatorIntl = this._userspaginator._intl;
            paginatorIntl.nextPageLabel = this.variable.nextPage;
            paginatorIntl.previousPageLabel = this.variable.previousPage;
            if (this.dataSourceVerticalSDetails) {
                this.dataSourceVerticalSDetails.paginator = this._userspaginator;
            }
        }
    }


    constructor(
        public loadingService: LoadingService,
        private loginService: LoginService,
        public customerService: CustomerService,
        public verticalSolutionService: VerticalSolutionsService,
        private variable: TranslatedVariables,
        public navigateService: NavigateService,
        private router: Router
    ) {}

    async ngOnInit() {
        this.isLoading = true;
        this.loadingService.setLoading(this.isLoading);
        //BindData
        this.customerService.companyInfo$.subscribe(async (companyInfo) => {
            if (!companyInfo) return;
            await this.BindData(this.verticalSolutionService.currentCodiceAzienda);
        });
    }

    private async BindData(codiceAzienda: string) {
        this.authorizationStored = this.loginService.getauthinfo();
        this.authorizationProperties = JSON.parse(this.authorizationStored);
        this.dataSourceVerticalSDetails = new MatTableDataSource<ProductDto>();
        let result: OperationResult = await this.verticalSolutionService.getAllProductsByReseller(codiceAzienda, false, false);
        this.dataSourceVerticalSDetails.data = result.Content as ProductDto[];
        this.noItems = this.dataSourceVerticalSDetails.filteredData.length <= 0;
        this.dataSourceVerticalSDetails.paginator = this._userspaginator;
        //this.dataSourceVerticalSDetails.sort = this._sort;
        this.solutionNumbers = this.dataSourceVerticalSDetails.data.length;
        this.isLoading = false;
        this.loadingService.setLoading(this.isLoading);
    }
    // -----------------------------------------------------------------------------
    applyFilterSearch(event: any) {
        const filterValue = (event.target as HTMLInputElement).value;
        this.dataSourceVerticalSDetails.filter = filterValue.trim().toLowerCase();
        this.solutionNumbers = this.dataSourceVerticalSDetails.filteredData.length;
        this.noItems = this.dataSourceVerticalSDetails.filteredData.length <= 0;
    }
    // -----------------------------------------------------------------------------
    clearUserSearch() {
        this.searchSolution = '';
        this.dataSourceVerticalSDetails.filter = this.searchSolution.trim().toLowerCase();
        this.noItems = false;
        this.solutionNumbers = this.dataSourceVerticalSDetails.data.length;
    }
    // -----------------------------------------------------------------------------
    goToEdit(prod: ProductDto) {
        this.navigateService.setLocalStorageData('selectedSolution', JSON.stringify(prod));
        this.router.navigate(['vertical-solutions/insert-new-solution']);
    }
    // -----------------------------------------------------------------------------
    goToNew(isNew: boolean) {
        this.navigateService.goToVerticalSolutionInsertNewSolution(isNew);
    }
    // -----------------------------------------------------------------------------
    getActiveDescription(isActive: boolean) {
        return isActive ? this.variable.yes : this.variable.no;
    }
}
